import React from "react";
import pp from "../Assets/SPJ_PC_07_2026.jpeg";
export default function Price() {
  return (
    <div className="mt-28 flex justify-center items-center">
      <img src={pp} alt="Pricing" />
    </div>
  );
}
